export default __webpack_public_path__ + "static/media/download-file.ec6ddb65.png";